module.exports = __webpack_public_path__ + "static/media/king_of_diamonds.658998b1.svg";